import { string } from 'prop-types';
import React from 'react';
import './style.scss';
/**
 * Mapper Service Empty text block when no recommendations
 */
function EmptyBlock({ emptyBlockTextArr }) {
  return (
    <div className="mapper-service-empty-block pr20 pl20">
      {emptyBlockTextArr.map((text) => (
        <p className="arc-color-B55 arc-support">
          { text}
        </p>
      ))}
    </div>
  );
}

export default EmptyBlock;

EmptyBlock.propTypes = {
  emptyBlockTextArr: string,
};

EmptyBlock.defaultProps = {
  emptyBlockTextArr: '',
};
